const CREDITS_PER_YUAN = 100;

export function creditsToYuan(credits: number): string {
  const yuan = credits / CREDITS_PER_YUAN;
  if (yuan === 0) return '0';
  if (Number.isInteger(yuan)) return yuan.toLocaleString('zh-CN');
  return yuan.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
